import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';
import { VisitSettlement, VisitSettlementQuery } from '@dreryk/egabinet-financial-settlement-frontend-api';
import { PurchaseId } from '@dreryk/egabinet-financial-settlement-published-language-api';

import { performCqrsQueryFind } from '@dreryk/command-query-react-common';

export const performVisitSettlementCqrsFind = async (appointmentId: number): Promise<VisitSettlement | null> => {
   const currentVisitSettlement = await performCqrsQueryFind<VisitSettlement>(() => {
      const query = new VisitSettlementQuery();
      query.purchaseIds = [PurchaseId.forAppointment(AppointmentId.of(appointmentId))];
      return query;
   });

   return currentVisitSettlement;
};
